import React from 'react';
import Video from "./Video.tsx";

interface VideosProps {
    offset: number;
    iterObject: any[];
    editedContent: any;
    setEditedContent: any;
    isEditing: boolean;
}

const Videos: React.FC<VideosProps> = (
    {
        offset,
        iterObject,
        editedContent = null,
        setEditedContent = null,
        isEditing
    }) => {
    const handleRemoveVideo = (index: number) => {
        const updatedContent = [...editedContent];
        updatedContent.splice(index, 1);
        setEditedContent(updatedContent);
    };

    return (
        <>
            {iterObject.length > 0 && (
                <div className="bg-neutral-100 dark:bg-neutral-900 my-3 rounded-2xl border border-neutral-800 overflow-hidden">
                    <div className="flex overflow-x-auto">
                        {iterObject.map((item: any, index: number) => {
                            const videoIndex = offset + index;
                            return (
                                <div key={videoIndex} className="flex-none relative mx-auto">
                                    <Video item={item} />
                                    {isEditing && (
                                        <button
                                            className="absolute top-1.5 right-1.5 bg-red-800 text-white border-none rounded-full w-5 h-5 text-xs flex justify-center items-center cursor-pointer"
                                            onClick={() => handleRemoveVideo(videoIndex)}
                                        >
                                            &times;
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default Videos;